export function EngagementsPage() {
  return <div className="text-gray-500">Engagements page - coming soon.</div>
}
